
define(
	'Tavanoteam.TavanoTeam_Banner_Extension.Banner'
	, [
		'Banner.View'
	]
	, function (
		BannerView
	) {
		
		'use strict';

		return {

			mountToApp: function mountToApp(container) {

				container.getComponent('CMS').registerCustomContentType({

					// this property value MUST be lowercase
					id: 'cct_tavanoteam_banner'

					// The view to render the CCT
					, view: BannerView
				});
			}
		};
	}
);
